"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingCustomerSalesOrderCount = void 0;
const React = require("react");
const Icon_1 = require("../../../../../../components/base/atoms/Icon");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PendingCustomerSalesOrderCount");
const PendingCustomerSalesOrderCount = ({ salesOrderCount, isExpanded, toggleVisibility }) => (React.createElement("div", { className: css(""), onClick: toggleVisibility },
    React.createElement("span", null,
        "You have ",
        salesOrderCount,
        " pending order",
        salesOrderCount > 1 && "s"),
    React.createElement("span", { className: css("expandIcon", { "-isExpanded": isExpanded }) },
        React.createElement(Icon_1.Icon, { name: "chevron-right" }))));
exports.PendingCustomerSalesOrderCount = PendingCustomerSalesOrderCount;
//# sourceMappingURL=index.js.map